export const jobs = [
  { color: '#FD9579', label: 'Babysit', value: 'babysit', income: 0 },
  { color: '#219ad3', label: 'Tutoring', value: 'tutoring', income: 0 },
  { color: '#86cc6a', label: 'Clothing Sales', value: 'clothingsales', income: 0 },
  { color: '#59286e', label: 'Dance Classes', value: 'danceclasses', income: 0 },
];

export const transactions = [
  {
    job: 'babysit',
    source: 'Mueller Family',
    amount: 30,
    timestamp: 1606999499,
  },
  {
    job: 'babysit',
    source: 'Bauer Family',
    amount: 50,
    timestamp: 1606826699,
  },
  {
    job: 'clothingsales',
    source: 'Vinted',
    amount: 22,
    timestamp: 1606826699,
  },
  { job: 'clothingsales', source: 'eBay', amount: 8, timestamp: 1605876299 },
  {
    job: 'danceclasses',
    source: 'TV Baienfurt',
    amount: 64,
    timestamp: 1606221899,
  },
  {
    job: 'tutoring',
    source: 'Berg Family',
    amount: 10,
    timestamp: 1606481099,
  },
];